import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

export default function Title ({
  size,
  Element,
  extraClass,
  dangerouslySetInnerHTML,
  children
}) {
  const data = getDataFromSize(size)
  Element = Element || data.Element
  const className = classnames(data.className, extraClass)

  return (
    <Element
      className={className}
      children={children}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    />
  )
}

function getDataFromSize (size) {
  return {
    Element: `h${size}`,
    className: `h${size}`
  }
}

Title.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
  Element: PropTypes.node,
  extraClass: PropTypes.string
}
